import { axiosInstance as axios } from "@/utils/wd_axios.js";
import {  userKeys, wdConfigData } from "@/service/wd_app_config.js";


// 创建支付订单 /api/wechatpay/create
export const api_create_pay = (params) => {
  var user = JSON.parse(localStorage.getItem(userKeys.key_userObject))
  var globalAccessToken = localStorage.getItem(userKeys.key_globalAccessToken);
  var accessToken = localStorage.getItem(userKeys.key_corporationAccessToken)
  var url = `${wdConfigData.baseURLPaymentApi}/pay/order/create`
  return axios.post(url, params, {
    headers: {
      AccessToken: accessToken,
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
};

// 轮询订单支付状态 /api/wechatpay/OrderStatus?orderNo=20250603214241000000000995273661
export const api_query_order_status = (orderNo) => {
  var globalAccessToken = localStorage.getItem(userKeys.key_globalAccessToken);
  var accessToken = localStorage.getItem(userKeys.key_corporationAccessToken);
  var url = `${wdConfigData.baseURLPaymentApi}/pay/order/status?orderNo=${orderNo}`;
  return axios.get(url, {
    headers: {
      Authorization: `Bearer ${globalAccessToken}`,
      AccessToken: accessToken,
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
};

// 创建StripeSession /create/checkout/session
export const create_checkout_session = (params) => {
  var accessToken = localStorage.getItem(userKeys.key_corporationAccessToken)
  var url = `${wdConfigData.baseURLPaymentApi}/create/checkout/session`
  return axios.post(url, params, {
    headers: {
      AccessToken: accessToken,
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
};

// 获取产品订阅类型 /Plan/Plans
export const api_get_palns = () => {
  var user = JSON.parse(localStorage.getItem(userKeys.key_userObject));
  var globalAccessToken = localStorage.getItem(userKeys.key_globalAccessToken);
  var accessToken = localStorage.getItem(userKeys.key_corporationAccessToken);
  var url = `${wdConfigData.baseURLSubsApi}/Plan/Plans`;
  return axios.get(url, {
    headers: {
      Authorization: `Bearer ${globalAccessToken}`,
      AccessToken: accessToken,
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
};

// 获取用户订阅余额 /Subscription/User/Subscriptions
export const api_get_subscription_balance = () => {
  var globalAccessToken = localStorage.getItem(userKeys.key_globalAccessToken);
  var accessToken = localStorage.getItem(userKeys.key_corporationAccessToken);
  var url = `${wdConfigData.baseURLSubsApi}/Subscription/User/Subscriptions`;
  return axios.get(url, {
    headers: {
      Authorization: `Bearer ${globalAccessToken}`,
      AccessToken: accessToken,
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
};

// 获取用户订阅购买记录 /Subscription/User/SubscriptionRecords
export const api_get_user_sbuscription_purchase_records = () => {
  var globalAccessToken = localStorage.getItem(userKeys.key_globalAccessToken);
  var accessToken = localStorage.getItem(userKeys.key_corporationAccessToken);
  var url = `${wdConfigData.baseURLSubsApi}/Subscription/User/SubscriptionRecords`;
  return axios.get(url, {
    headers: {
      Authorization: `Bearer ${globalAccessToken}`,
      AccessToken: accessToken,
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
};

//Subscription/UsageLog/Users/{userId}/GetMonthlyList
export const api_get_monthly_use_logs = () => {
  var globalAccessToken = localStorage.getItem(userKeys.key_globalAccessToken);
  var accessToken = localStorage.getItem(userKeys.key_corporationAccessToken);
  var user = JSON.parse(localStorage.getItem(userKeys.key_userObject));
  var url = `${wdConfigData.baseURLSubsApi}/Subscription/UsageLog/Users/${user.Id}/GetMonthlyList?start=0&count=2000`;
  return axios.get(url, {
    headers: {
      Authorization: `Bearer ${globalAccessToken}`,
      AccessToken: accessToken,
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
};

// // 获取Gpt Talk的消息列表
// // Users/{当前UserId}/Talks/{TalkId}/Messages?start=0&count=3
// export const wd_getGptTalkMessageList = (params) => {
//   var user = JSON.parse(localStorage.getItem(userKeys.key_userObject));
//   var accessToken = localStorage.getItem(userKeys.key_corporationAccessToken);
//   var url = `${wdConfigData.baseURLApi}/Users/${user.Id}/Talks/${params.talkId}/Messages?start=${params.start}&count=${params.count}`;
//   return axios.get(url, {
//     headers: {
//       AccessToken: accessToken,
//       "Content-Type": "application/x-www-form-urlencoded",
//     },
//   });
// };

// // 咨询Gpt
// // post
// // Talks/{talkId}/Messages/Create
// export const wd_askGpt = (params) => {
//   var requestBody = {
//     Text: params.promptText,
//   };
//   var accessToken = localStorage.getItem(userKeys.key_corporationAccessToken);
//   var url = `${wdConfigData.baseURLApi}/Talks/${params.talkId}/Messages/Create`;
//   return axios.post(url, requestBody, {
//     headers: {
//       AccessToken: accessToken,
//       "Content-Type": "application/x-www-form-urlencoded",
//     },
//   });
// };

// // 取消gpt排队
// // post
// // Corporations/{corpId}/Users/{userId}/Talks/{talkId}/Queues/{queueId}/2
// export const wd_cancelGptQueue = (params) => {
//   var user = JSON.parse(localStorage.getItem(userKeys.key_userObject));
//   var corporationId = JSON.parse(
//     localStorage.getItem(userKeys.key_corporationId)
//   );
//   var accessToken = localStorage.getItem(userKeys.key_corporationAccessToken);
//   var url = `${wdConfigData.baseURLApi}/Corporations/${corporationId}/Users/${user.Id}/Talks/${params.talkId}/Queues/${params.queueId}/2`;
//   return axios.post(url, "", {
//     headers: {
//       AccessToken: accessToken,
//       "Content-Type": "application/x-www-form-urlencoded",
//     },
//   });
// };

// // 获取预置提问列表
// // get
// // /App/{userId}/GPT/Config/{configId}/PreProblem/GetList
// export const wd_getGptPrePromptList = (params) => {
//   var user = JSON.parse(localStorage.getItem(userKeys.key_userObject));
//   var accessToken = localStorage.getItem(userKeys.key_corporationAccessToken);
//   var url = `${wdConfigData.baseURLApi}/App/${user.Id}/GPT/Config/${params.configId}/PreProblem/GetList`;
//   return axios.get(url, {
//     headers: {
//       AccessToken: accessToken,
//       "Content-Type": "application/x-www-form-urlencoded",
//     },
//   });
// };

// // 给Gpt答案打分，有用80，没用40
// // post
// // Talks/{talkId}/Answers/{messageId}/Score/80
// export const wd_scoreAnswer = (params) => {
//   var accessToken = localStorage.getItem(userKeys.key_corporationAccessToken);
//   var url = `${wdConfigData.baseURLApi}/Talks/${params.talkId}/Answers/${params.messageId}/Score/${params.score}`;
//   return axios.post(url, "", {
//     headers: {
//       AccessToken: accessToken,
//       "Content-Type": "application/x-www-form-urlencoded",
//     },
//   });
// };

// // 获取GPT问答列表
// // get
// // Users/{GPT的UserId}/GPTAnswers?start=0&count=3
// export const wd_getGptQandAList = (params) => {
//   var user = JSON.parse(localStorage.getItem(userKeys.key_userObject));
//   var accessToken = localStorage.getItem(userKeys.key_corporationAccessToken);
//   var url = `${wdConfigData.baseURLApi}/Users/${user.Id}/GPTAnswers?start=${params.start}&count=${params.count}&configId=${params.gptConfigId}`;
//   return axios.get(url, {
//     headers: {
//       AccessToken: accessToken,
//       "Content-Type": "application/x-www-form-urlencoded",
//     },
//   });
// };

export const subscriptionApi = {
    async getUserSubscriptions() {
        // 模拟API延迟
        await new Promise(resolve => setTimeout(resolve, 500));
        return {
            total: 1000,
            used: 350,
            remaining: 650,
            subscriptions: [
                {
                    id: 1,
                    type: '试用套餐',
                    price: 0,
                    purchaseDate: '2024-01-15',
                    expiryDate: '2024-07-15',
                    status: 'expired',
                    remaining: 0
                },
                {
                    id: 2,
                    type: '次数套餐',
                    price: 15,
                    purchaseDate: '2023-12-01',
                    expiryDate: '2024-06-01',
                    status: 'expired',
                    remaining: 0
                },
                {
                    id: 3,
                    type: '月套餐',
                    price: 59,
                    purchaseDate: '2024-05-20',
                    expiryDate: '2024-11-20',
                    status: 'active',
                    remaining: 50
                },
                {
                    id: 4,
                    type: '季套餐',
                    price: 159,
                    purchaseDate: '2025-05-20',
                    expiryDate: '2025-8-20',
                    status: 'active',
                    remaining: 150
                },
                {
                    id: 5,
                    type: '年套餐',
                    price: 599,
                    purchaseDate: '2025-04-20',
                    expiryDate: '2026-4-20',
                    status: 'active',
                    remaining: 1500
                },
                {
                    id: 6,
                    type: '图片月套餐',
                    price: 35,
                    purchaseDate: '2025-05-10',
                    expiryDate: '2025-06-10',
                    status: 'active',
                    remaining: 5
                },
                {
                    id: 7,
                    type: '图片年套餐',
                    price: 149,
                    purchaseDate: '2025-05-15',
                    expiryDate: '2026-05-15',
                    status: 'active',
                    remaining: 50
                }
            ]
        };
    },

    async getProducts() {
        await new Promise(resolve => setTimeout(resolve, 300));
        return [
            {
                id: 1,
                title: '试用套餐',
                description: '适合个人用户订阅',
                price: 0,
                features: ['每天送20 AI创作点数 & 2 AI生图点数（当天有效）', '5天有效']
            },
            {
                id: 2,
                title: '次数套餐',
                description: '适合个人用户订阅',
                price: 15,
                features: ['40 AI创作点数', '1个月有效']
            },
            {
                id: 3,
                title: '月套餐',
                description: '适合个人用户订阅',
                price: 59,
                features: ['200 AI创作点数', '1个月有效']
            },
            {
                id: 4,
                title: '季套餐',
                description: '适合中小企业订阅',
                price: 159,
                features: ['600 AI创作点数', '3个月有效']
            },
            {
                id: 5,
                title: '年套餐',
                description: '适合中小企业订阅',
                price: 599,
                features: ['2400 AI创作点数', '1年有效']
            },
            {
                id: 6,
                title: '图片月套餐',
                description: '适合个人用户订阅',
                price: 35,
                features: ['50 AI生图点数', '1个月有效']
            },
            {
                id: 7,
                title: '图片年套餐',
                description: '适合中小企业订阅',
                price: 149,
                features: ['50 AI生图点数', '1年有效']
            }
        ];
    },

    async createOrder(productId) {
        await new Promise(resolve => setTimeout(resolve, 1000));
        return {
            orderId: 'ORDER_' + Date.now(),
            qrCodeUrl: 'https://via.placeholder.com/200x200/667eea/ffffff?text=QR+Code',
            amount: [99, 199, 399][productId - 1]
        };
    },

    async checkPaymentStatus(orderId) {
        await new Promise(resolve => setTimeout(resolve, 500));
        // 模拟随机支付结果
        return Math.random() > 0.7 ? 'success' : 'pending';
    }
};